import React, {
  Fragment,
  useRef,
  useState,
  useEffect,
  useContext,
  useCallback,
} from "react";
import FcardContact from "../../components/FcardContact/FcardContact";
import FcardGroup from "../../components/FcardGroup/FcardGroup";
import FcardPageTitle from "../../components/FcardPageTitle/FcardPageTitle";
import { useNavigate, useLocation } from "react-router";
import FBannerSpendResponsive from "../../components/FBannerSpendResponsive/FBannerSpend";
import FcardPaymentMethod from "../../components/FcardPaymentMethod/FcardPaymentMethod";
import FInput from "../../components/FInput/FInput";
import FBillContainer from "../../components/FBillContainer/FBillContainer";
import FCreditCard from "../../components/FCreditCard/FCreditCard";
import { useCards } from "../../hooks/useCards";
import { AuthContext } from "../../context/AuthContext";
import { v4 as uuid } from "uuid";
import { useProcessor } from "../../hooks/useProcessor";
import { array } from "i/lib/util";
import { useCurrencyFormat } from "../../hooks/useCurrencyFormat";
import { CloseOutline } from "react-ionicons";

// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
// Import Swiper styles
import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";
import "./style/BillScreen.module.scss";
// import required modules
import { EffectCoverflow, Pagination } from "swiper";

import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import FInputt from "../../components/FInputt/FInputt";
import { useFormik } from "formik";
import FContainer from "../../components/FContainer/FContainer";
import VectorIcons from "../../components/VectorIcons/VectorIcons";

const BillScreen = ({ param }) => {
  const parameters = useLocation();

  const [selectCard, setSelectCard] = useState(null);
  const MySwal = withReactContent(Swal);

  const route = useNavigate();
  const { state } = useLocation();
  const [idempotencyKey, setIdempotencyKey] = useState(null);
  const [arrayGroups, setArrayGroups] = useState([]);
  const [indexInfo, setIndexInfo] = useState(0);

  const {
    setLoading,
    cart,
    tokenDecoded,
    setCart,
    loading,
    removeError,
    errorMessage,
    setAlert,
    setPreviousScreenDefinite,
  } = useContext(AuthContext);
  const { request, products, details, processPayment, setRequest, createBill } =
    useProcessor();
  const { formatWithCurrencyISO } = useCurrencyFormat();

  const { getCard, cards } = useCards();

  const cardId = cards[indexInfo]?.id;

  useEffect(() => {
    setIdempotencyKey(uuid());
  }, []);

  useEffect(() => {
    getCard();
  }, []);

  useEffect(() => {
    let cardsGroup = [];

    for (const card of cards) {
      let myCard = {
        id: card.id,
        name: card.cardHolder.name,
        lastDigits: card.panLastDigits,
        expirationMonth: card.expirationMonth,
        expirationYear: card.expirationYear,
        type: card.mii,
      };
      cardsGroup.push(myCard);
      setSelectCard({ index: 0, id: card.id });
    }

    setArrayGroups(cardsGroup);
  }, [cards]);

  const onScroll = useCallback((event) => {
    const slideSize = event.nativeEvent.layoutMeasurement.width;
    const index = event.nativeEvent.contentOffset.x / slideSize;
    const roundIndex = Math.round(index);
    setIndexInfo(roundIndex);
  }, []);

  useEffect(() => {
    if (state == null) {
      route("/");
    } else {
      let products = [
        {
          id: "FIADO_FLASH_USD_MXN",
          amount: state.amount,
        },
      ];

      //Check if key exists
      //TODO: REFACTORIZAR ESTO.
      let exchangeRate = cart.filter((element) =>
        Object.keys(element).includes("exchangeRate")
      )[0];
      let fiadoSubscription = cart.filter((element) =>
        Object.keys(element).includes("fiadoSubscription")
      )[0];
      let fiadoProduct = cart.filter((element) =>
        Object.keys(element).includes("fiadoProduct")
      )[0];
      let paymentMethod = cart.filter((element) =>
        Object.keys(element).includes("paymentMethod")
      )[0];
      //let originCurrencyId = exchangeRate?.exchangeRate?.originCurrencyId.toString();
      //let destinationCurrencyId = exchangeRate?.exchangeRate?.destinationCurrencyId.toString();
      let exchange = exchangeRate?.exchangeRate?.exchangeRate?.id;

      exchangeRate =
        exchangeRate?.exchangeRate?.exchangeRate?.id &&
        fiadoProduct?.fiadoProduct?.id
          ? {
              id: fiadoProduct?.fiadoProduct?.id,
              amount: parseInt(exchangeRate?.exchangeRate?.capturedAmount),
            }
          : undefined;
      if (exchangeRate != undefined) {
        products.push(exchangeRate);
      }
      fiadoSubscription = fiadoSubscription?.fiadoSubscription?.id
        ? { id: fiadoSubscription?.fiadoSubscription?.id }
        : undefined;
      if (fiadoSubscription != undefined) {
        products.push(fiadoSubscription);
      }

      paymentMethod = paymentMethod?.paymentMethod?.id
        ? {
            id: paymentMethod?.paymentMethod?.id,
            paymentMethod: {
              paymentMethodId: cardId,
              value: null,
            },
          }
        : undefined;
      if (paymentMethod != undefined) {
        products.push(paymentMethod);
      }

      // console.log('DATOSSSS')
      const datos = {
        exchangeRateId: state.exchangeRateId,
        originCurrencyId: state.originCurrencyId,
        destinationCurrencyId: state.destinationCurrencyId,
        // sourceDirectoryId: tokenDecoded.directoryId,
        sourceDirectoryId: JSON.parse(localStorage.getItem("tokenDecoded")),
        products,
      };

      //console.log(request.originCurrencyId)

      setRequest(datos);
      createBill(datos);
    }
  }, []);

  return (
    <>
      {state != null ? (
        <>
          <FContainer>
            {arrayGroups.length > 0 ? (
              <>
                <Swiper
                  effect={"coverflow"}
                  grabCursor={true}
                  centeredSlides={true}
                  slidesPerView={1}
                  edgeSwipeThreshold={20}
                  // pagination={true}
                  coverflowEffect={{
                    rotate: 10,
                    stretch: 5,
                    depth: 50,
                    modifier: 3,
                    slideShadows: false,
                  }}
                  modules={[EffectCoverflow, Pagination]}
                  className="absolute w-full h-full border-0 rounded-r-3xl px-5"
                  onSlideChange={(e) => {
                    setSelectCard({
                      index: e.realIndex,
                      id: arrayGroups[e.realIndex].id,
                    });
                  }}
                >
                  {arrayGroups.length > 0
                    ? arrayGroups.map((item, index) => (
                        <SwiperSlide>
                          <>
                            <div
                              className={`absolute w-full h-full ${
                                selectCard.index == index ? " " : "hidden"
                              }`}
                            >
                              <div className="bg-[#52c41a] rounded-full grid place-items-center w-[30px] xxs:w-[35px] smm:w-[40px] h-[30px] xxs:h-[35px] smm:h-[40px] ml-[180px] xxs:ml-[240px] smm:ml-[280px]">
                                <VectorIcons
                                  name="checkmark-circle-outline"
                                  cssClasses="text-[15px]"
                                />
                              </div>
                            </div>
                            <FCreditCard
                              checked={selectCard.index == index}
                              lastDigits={item.lastDigits}
                              name={item.name}
                              expMonth={item.expirationMonth}
                              expYear={item.expirationYear}
                              type={item.type}
                            />
                          </>
                        </SwiperSlide>
                      ))
                    : null}
                </Swiper>
                <div
                  className="border-0 w-full font-bold text-Secondary text-[4vw] smm:text-[17px] py-2 grid place-items-end cursor-pointer"
                  onClick={() => {
                    setPreviousScreenDefinite(-1);
                    route("/CreateCardScreen");
                  }}
                >
                  Agregar nueva tarjeta
                </div>
              </>
            ) : (
              <>
                <div
                  className="w-full border-0 grid place-items-center cursor-pointer"
                  onClick={() => {
                    route("/CreateCardScreen");
                  }}
                >
                  <img
                    src={require("../../components/assets/images/addition.png")}
                    className="w-[120px] xxs:w-[130px] h-auto flex-1 pb-2"
                  />
                  <div className="font-bold text-[3.5vw] sm:text-[14px]">
                    No tienes tarjetas agregadas
                  </div>
                </div>
              </>
            )}
            <div className="w-full pt-5">
              <FBillContainer
                total={formatWithCurrencyISO(
                  details.grandTotal,
                  request.originCurrencyId
                )}
                btnTitle="Continuar"
                disabledButton={!(arrayGroups.length > 0)}
                products={products}
                btnOnChange={() => {
                  console.log(idempotencyKey);
                  MySwal.fire({
                    showCloseButton: true,
                    showCancelButton: false,
                    showConfirmButton: false,
                    html: (
                      <MySwalbody
                        MySwal={MySwal}
                        parameters={parameters.state}
                        selectCard={selectCard}
                        request={request}
                        idempotencyKey={idempotencyKey}
                        setLoading={setLoading}
                        processPayment={processPayment}
                        setCart={setCart}
                        setAlert={setAlert}
                        route={route}
                      />
                    ),
                  });
                }}
              />
            </div>
          </FContainer>
        </>
      ) : (
        route("/")
      )}
    </>
  );
};

const MySwalbody = ({
  MySwal,
  parameters,
  selectCard,
  request,
  idempotencyKey,
  setLoading,
  processPayment,
  setCart,
  setAlert,
  route,
}) => {
  const {
    productId,
    transferredAmount,
    originCurrency,
    destinationCurrencyId,
    idFiadoFlash,
  } = parameters;

  // const nextScreen = async (data, idempotencyKey) => {
  //   setLoading(true);
  //   // let response = await processPayment(data, idempotencyKey);
  //   // setLoading(false);
  //   // if (response?.data?.code == "PROCESS_OK") {
  //   //   setCart([]);
  //   //   const next = () => {
  //   //     route("/");
  //   //   };
  //   //   setAlert("Éxito", "Se procesó tu pago.", "SUCCESS", true, next);
  //   // }
  // };

  const formik = useFormik({
    initialValues: {
      cvv: "",
    },
    onSubmit: async (values) => {
      MySwal.close();

      const { cvv } = values;
      request.products.forEach((element) => {
        if (element.paymentMethod) {
          element.paymentMethod.paymentMethodId = selectCard.id;
          element.paymentMethod.value = cvv;
        }
      });

      let response = await processPayment(request, idempotencyKey);
      console.log("response", response);

      if (response?.data?.code == "PROCESS_OK") {
        Swal.fire({
          showCloseButton: true,
          title: 'Éxito',
          text: "Se procesó tu pago.",
          icon: 'success',
          showCancelButton: false,
          confirmButtonColor: '#fd6e0d',
          // iconColor: "#fd6e0d",
          confirmButtonText: 'Entendido'
        }).then((result) => {
          if (result.isConfirmed) {
            route("/");
          } else{
            route("/");
          }
        })
      } else {
        console.log(response);
      }
    },
    validate: (values) => {
      const errors = {};
      if (!values.cvv) {
        errors.cvv = "Ingresa el código de seguridad de tu tarjeta";
      } else {
        if (values.cvv.length < 3) {
          errors.cvv = "Debe tener 3 o 4 dígitos";
        }
      }
      return errors;
    },
  });

  return (
    <>
      <form onSubmit={formik.handleSubmit}>
        <div className="border-0 grid place-items-center pt-3">
          <img
            src={require("../../components/assets/images/cvv.png")}
            className="w-[100px] sm:w-32"
          />
          <div className="font-bold text-large text-black">Ingresa tu cvv</div>
          <div className=" border-0 w-full text-large text-black mt-1 px-5 xs:px-14">
            <FInputt
              type="password"
              name="cvv"
              title=""
              inputmode={"numeric"}
              placeholder="Ingresa tu cvv"
              formik={formik}
              maxLength={4}
              onChange={(e) => {
                formik.setFieldValue("cvv", e);
              }}
            />
          </div>
          <div className="font-regular text-[15px] text-black mt-5">
            <FInputt
              type="botton"
              disabled={formik.isValid && formik.dirty}
              className={
                !(formik.isValid && formik.dirty)
                  ? "px-[90px] py-[12px] xs:px-[120px] md:py-[12px] rounded-2xl text-black bg-colorDisabled"
                  : "px-[90px] py-[12px] xs:px-[120px] md:py-[12px] rounded-2xl text-white bg-primary"
              }
              title="Continuar"
              onChange={formik.handleSubmit}
            />
          </div>
        </div>
      </form>
    </>
  );
};

export default BillScreen;
